module.exports = __webpack_public_path__ + "img/logo.b09a4871.png";